import React from 'react';
import { Modal } from 'react-bootstrap';
import { Button, ModifyDeclineReasons } from '..';
import { IconExclamation } from '../../assets/icons';
import { TranslationUtils } from '../../utils';
import './ModifyGuestAlertsModal.scss';

interface ModifyGuestAlertsModal {
    show: boolean;
    handleClose: () => any;
    declineReason: ModifyDeclineReasons | null;
    phone: string;
}

export const ModifyGuestAlertsModal: React.FC<ModifyGuestAlertsModal> = (props) => {
    const { show, handleClose, declineReason, phone } = props;

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton />
            <div className="required-modal-text">
                <div className="modal-title">
                    <div className="modal-title-icon">
                        <IconExclamation className="d-none d-md-block" />
                    </div>
                    <h4 className={'heading-med-light'}>{TranslationUtils.get('option_unavailable')}</h4>
                </div>
                <div className="mb-4" />

                <div>
                    {declineReason === ModifyDeclineReasons.TRIP_ALREADY_STARTED && (
                        <React.Fragment>
                            <p className={'body-regular'}>{TranslationUtils.get('trip_eligibility_trip_already_started')}</p>
                            <div className="body-regular phone-wrap">
                                {TranslationUtils.get('local')} {phone}
                            </div>
                        </React.Fragment>
                    )}

                    {declineReason === ModifyDeclineReasons.SOURCE_NOT_ALLOWED && (
                        <React.Fragment>
                            <p className={'body-regular'}> {TranslationUtils.get('trip_eligibility_not_allowed_for_occupancy')}</p>
                        </React.Fragment>
                    )}

                    {declineReason === ModifyDeclineReasons.CREATED_BEFORE_JUNE_2018 && (
                        <React.Fragment>
                            <p className={'body-regular'}> {TranslationUtils.get('trip_eligibility_created_before_june_fourth_2018')}</p>
                            <div className="body-regular phone-wrap">
                                {TranslationUtils.get('local')} {phone}
                            </div>
                        </React.Fragment>
                    )}

                    {declineReason === ModifyDeclineReasons.REFUND_IN_PROGRESS && (
                        <React.Fragment>
                            <p className={'body-regular'}> {TranslationUtils.get('trip_eligibility_refund_in_progress')}</p>
                            <div className="body-regular phone-wrap">
                                {TranslationUtils.get('local')} {phone}
                            </div>
                        </React.Fragment>
                    )}
                </div>
            </div>
            <div className="required-modal-body">
                <div className="divider-column">
                    <Button
                        id="button-close-modifyGuestAlerts"
                        className="body-regular action-button"
                        onClick={handleClose}
                        label={TranslationUtils.get('close')}
                        variant="default"
                        block
                    />
                </div>
            </div>
        </Modal>
    );
};
